import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {environment} from '../../../environments/environment';

import {Observable} from 'rxjs';

import {OrganizationUser} from '../../afb-api/models/organization-user';
import {Simple200Response} from '../../afb-api/models/general';
import {map} from 'rxjs/internal/operators';

@Injectable()
export class OrgService {

  constructor(private httpClient: HttpClient) {
  }

  /**
   *  Organization-Users APIs
   */
  // Retrieve orgUsers given specific Organization
  requestOrgUserList(orgToken: string): Observable<OrganizationUser[]> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${orgToken}`});
    const url = `${environment.afbV2Host}org-users`;

    return this.httpClient
      .get<{ data: OrganizationUser[] }>(url, {headers})
      .pipe(
        map(response => response.data)
      );
  }

  /**
   * User Status APIs
   */
  finishOnboarding(orgToken: string): Observable<Simple200Response> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${orgToken}`,
      'Content-Type': 'application/json'
    });
    const url = `${environment.afbV2Host}org-users/self`;

    return this.httpClient
      .patch<{ message: string }>(url, {'hasOnboarded': true}, {headers});
  }
}
